const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID?.trim();

const VALID_ID = /^G-[A-Z0-9]+$/.test(MEASUREMENT_ID || "");

const TRACKED_PUBLIC_ROUTES = new Set([
  "/",
  "/faq",
  "/contact",
  "/privacy-policy",
  "/terms-and-conditions",
  "/services",
  "/simulations",
]);

let initialized = false;
let lastTrackedPath = null;

function normalizePath(pathname) {
  return pathname?.replace(/\/+$/, "") || "/";
}

function updateConsent(granted) {
  if (!VALID_ID) {
    return;
  }

  window[`ga-disable-${MEASUREMENT_ID}`] = !granted;

  if (initialized && window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
}

function initializeGA4() {
  if (!VALID_ID || initialized) {
    return;
  }

  initialized = true;

  window.dataLayer = window.dataLayer || [];

  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  window.gtag("js", new Date());

  window.gtag("config", MEASUREMENT_ID, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  const script = document.createElement("script");

  script.id = "legup-ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;

  document.head.appendChild(script);
}

export function syncGoogleAnalytics(pathname, consentAllowed) {
  if (!VALID_ID || typeof window === "undefined") {
    return;
  }

  const path = normalizePath(pathname);

  const shouldTrack =
    consentAllowed === true && TRACKED_PUBLIC_ROUTES.has(path);

  if (!shouldTrack) {
    updateConsent(false);
    lastTrackedPath = null;
    return;
  }

  updateConsent(true);
  initializeGA4();

  if (lastTrackedPath === path) {
    return;
  }

  lastTrackedPath = path;

  const safeUrl = `${window.location.origin}${path}`;

  window.gtag("event", "page_view", {
    send_to: MEASUREMENT_ID,
    page_title: document.title,
    page_location: safeUrl,
    page_path: path,
  });
}
